import { ConsentVerification } from "../components/consent/ConsentVerification";

export function ConsentPage() {
  return <ConsentVerification />;
}
